import React, { useState } from 'react'
import {
	CreateTripDraft,
	isUsingCustomName,
	setCurrencyCode,
	setCustomName,
	suggestedName,
} from './core/draft'
import { stepTitle } from './core/presentation'
import CurrencyTile from './CurrencyTile'
import { NameField, SectionHeading } from './NameStep.styles'
import { Heading } from './shared.styles'
import { TestIds } from '@/testIds'

interface NameStepProps {
	draft: CreateTripDraft
	onChange: (draft: CreateTripDraft) => void
}

/**
 * Step 3 — name and currency: the suggestion shows as a hint the user types
 * over (an empty field falls back to it), and the currency tile opens the
 * picker for the trip's default.
 */
const NameStep: React.FC<NameStepProps> = ({ draft, onChange }) => {
	// The field's in-progress text. The draft normalizes blank — or the
	// suggestion typed back — to "no custom name", so binding the input straight
	// to the draft would clear it mid-keystroke; local text keeps typing honest
	// and blur snaps the display back to the hint state.
	const [text, setText] = useState(draft.customName ?? '')

	const handleChange = (value: string) => {
		setText(value)
		onChange(setCustomName(draft, value))
	}

	const handleBlur = () => {
		if (!isUsingCustomName(draft)) setText('')
	}

	return (
		<div>
			<Heading as="h2">{stepTitle('name')}</Heading>
			<NameField
				id="create-trip-name"
				data-testid={TestIds.tripCreate.nameField}
				aria-label="Trip name"
				type="text"
				value={text}
				onChange={e => handleChange(e.target.value)}
				onBlur={handleBlur}
				placeholder={suggestedName(draft)}
				maxLength={64}
				autoFocus
			/>

			<SectionHeading as="h2">Default Currency</SectionHeading>
			<CurrencyTile value={draft.currencyCode} onChange={code => onChange(setCurrencyCode(draft, code))} />
		</div>
	)
}

export default NameStep
